import BaseApiService from '../baseApi.service';

export default class InterestsService extends BaseApiService {
  readonly basePath: string = 'memberships/v1/get-interests';
  constructor(props = null) {
    super(props);
  }
}
